import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('Browse Categories');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelectedLabel(cat.name);
    setIsOpen(false);
    window.open(cat.url, '_blank', 'noopener');
  };

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Browse Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Select a category below to explore our curated Sugargoo Spreadsheet product database organized by type.
          </p>
        </div>

        <div className="relative max-w-md mx-auto" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-3.5 bg-background-100 border border-background-200/70 rounded-lg text-foreground-800 font-medium text-sm transition-all hover:border-primary-300 cursor-pointer"
          >
            <span className="whitespace-nowrap">{selectedLabel}</span>
            <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 rounded-lg border border-background-200/70 overflow-hidden z-40 max-h-[380px] overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => handleSelect(cat)}
                  className="w-full text-left px-5 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap border-b border-background-100 last:border-b-0 cursor-pointer"
                >
                  {cat.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}